var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.10083 18.2642C13.9988 18.2642 17.9673 14.2957 17.9673 9.3977C17.9673 4.49973 13.9988 0.53125 9.10083 0.53125C4.20285 0.53125 0.234375 4.49973 0.234375 9.3977C0.234375 14.2957 4.20285 18.2642 9.10083 18.2642ZM4.29152 9.2056L12.8403 5.90949C13.237 5.76615 13.5836 6.00628 13.455 6.60625L13.4557 6.60551L12.0002 13.463C11.8923 13.9491 11.6034 14.0674 11.1992 13.8383L8.98261 12.2047L7.91346 13.2347C7.79524 13.3529 7.69549 13.4526 7.46644 13.4526L7.62382 11.1969L11.7319 7.4855C11.9108 7.32812 11.692 7.23946 11.4563 7.3961L6.37957 10.5925L4.19103 9.90974C3.71594 9.75901 3.70559 9.43465 4.29152 9.2056Z",
    fill: "#01C1EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram-icon.ed19c98029ee10f59ae7eef623d76deb.svg";
export { ForwardRef as ReactComponent };